package one.healthium.content.navigation.media

import androidx.compose.runtime.Composable
import one.healthium.insights.ui.player.VideoPlayerScreen

@Composable
fun VideoPlayerContent(component: VideoPlayerComponent) {
    VideoPlayerScreen(component.url, component)
}